export const ltrim = (str: string, charlist?: string): string => {
	if (charlist === undefined) charlist = ' \\s\u00A0' // whitespace and non-breaking space
	return str.replace(new RegExp('^[' + charlist + ']+'), '')
}
